import { call, put, takeLatest } from 'redux-saga/effects';
import { getPreCostRoutine } from '@modules/orders-and-trips/actions';
import { OrdersNTripsApi } from '@modules/orders-and-trips/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { TenderOutFastDeliveryServices } from '@modules/orders-and-trips/types/integrations';

function* getPreCostWorker(
  action: PayloadAction<{
    tripID: number;
    alias: TenderOutFastDeliveryServices[];
  }>
) {
  const { request, success, failure, fulfill } = getPreCostRoutine;
  const { tripID, alias } = action.payload;

  try {
    yield put(request());
    const {
      data: { data }
    } = yield call(OrdersNTripsApi.getPreCost, { tripID, alias: alias ?? [] });
    yield put(success({ data }));
  } catch (error) {
    yield put(failure({ error }));
  } finally {
    yield put(fulfill());
  }
}

export function* getPreCostWatcher() {
  yield takeLatest(getPreCostRoutine.trigger, getPreCostWorker);
}

